/**
 * GraphQL Configuration
 * Reads the GraphQL endpoint URL from environment variables
 * 
 * Note: NEXT_PUBLIC_ prefix is required for client-side environment variables in Next.js
 */

export const graphqlConfig = {
  /**
   * GraphQL API endpoint URL
   *
   * Always use relative path (/graphql) to go through Next.js proxy and avoid CORS.
   * The proxy in next.config.mjs will forward /graphql to the actual backend.
   * 
   * NOTE: We ignore NEXT_PUBLIC_GRAPHQL_URL to ensure all requests go through the proxy.
   */
  uri: '/graphql',

  /**
   * Additional Apollo Client configuration options
   */
  options: {
    // Enable caching
    cache: 'cache-first' as const,
    // Default fetch policy
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network' as const,
      },
      query: {
        fetchPolicy: 'cache-first' as const,
      },
      mutate: {
        fetchPolicy: 'no-cache' as const,
      },
    },
  },
};

/**
 * Get the GraphQL endpoint URL
 * @returns The GraphQL endpoint URL
 * @throws Error if URL is not configured
 */
export function getGraphQLUrl(): string {
  // Always return the relative proxy path - Next.js rewrites will handle forwarding to backend
  return graphqlConfig.uri;
}

